import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';

export default class TxtBtn extends Phaser.GameObjects.Container {
    constructor(scene, x, y, element, btnParent, state, index) {
        super(scene, x, y, []);
        scene.add.existing(this);
        this.scene = scene;
        this.element = element;
        this.state = state;
        this.isLock = true;
        this.index = index
        this.btnParent = btnParent;
        this.isDone = false;
        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });

        this.txt = this.scene.createTextElement(0, 0, element)
        this.add(this.txt);
        this.setLocked();

        this.on('pointerdown', () => {
            this.clickSound.play();
            this.btnParent.allTxtBtns.forEach(element => {
                if (element.isDone && element.index !== this.index) {
                    element.setUnlocked();
                }
            });
        })

    }

    setLocked() {
        this.txt.setAlpha(0.5);
        this.state = 'locked';
        this.disableInteractive();
    }

    setUnlocked() {
        this.isLock = false;
        this.txt.setAlpha(0.5);
        this.state = 'unlocked';
        this.setSize(this.txt.width, this.txt.height);
        this.setInteractive({ useHandCursor: true });
        // this.input.hitArea.setTo(this.w / 2 - 14, this.h / 2 - 14, this.w + 14, this.h + 14);
    }

    setClickFunction(clickFunction) {
        this.on('pointerup', () => {
            clickFunction(this);
        }, this.scene);
    }

    setActif() {
        this.isLock = false;
        this.state = 'actif';
        this.txt.setAlpha(1);
        this.isDone = true;
    }
}